<template>
  
  <div v-if="loading" class="loading-overlay">
    <div class="loading-container">
      <div class="spinner mt-3"></div>
      <div class="loading-text">Seohan</div>
    </div>
  </div>
    <div
      class="modal show d-block"
      id="productModal"
      tabindex="-1"
      aria-labelledby="productModalLabel"
      aria-hidden="true"
    >
    <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="d-flex modal-header justify-space-between">
        <div class="custom-font-title"> <v-icon class="custom-title-icon">mdi-file-document-edit</v-icon> <strong>Invoice Issue Page</strong></div>
        <v-col cols="9" class="d-flex justify-end gap-3">
            <!-- 확인 버튼 (Primary 스타일) -->
            <v-btn
                class="custom-confirm-btn"
                style = "padding-left: 10px; padding-right: 10px;"
                variant="elevated"
                @click="handleConfirm"
            >
            <v-icon class="btn-icon">mdi-check-circle</v-icon>
                <span class="text-lift-up">Confirm</span>
            </v-btn>

            <!-- 취소 버튼 (Neutral/Secondary 스타일) -->
            <v-btn
                color="grey"
                style = "padding-left: 10px; padding-right: 10px;"

                class="custom-cancel-btn"
                variant="outlined"
                @click="closeScreen"
            >
            <v-icon class="btn-icon">mdi-close-circle</v-icon>
                <span class="text-lift-up">Cancel</span>
            </v-btn>
            </v-col>

        </div>

        <v-container>
            
            <v-card class="custom-card-box mb-4">
                <v-card-title class="custom-card-title">
                    Delivery Transportation Info
                </v-card-title>
                <v-row class="mt-1">
                    <v-col cols="3" class="pr-2 mb-2 ml-2 mr-2">
                        <v-menu :disabled="isDestinationAutoSelected">
                            <template v-slot:activator="{ props }">
                            <div class="split-box" v-bind="props">
                                <div class="label-box">Destination</div>
                                <div class="select-box">
                                {{ selectedDestination || "Select Destination" }}
                                </div>
                            </div>
                            </template>
                            <v-list class="custom-dropdown-list">
                            <v-list-item
                                v-for="(destination, index) in destinationList"
                                :key="index"
                                :style="{ padding: '15px' }"
                                @click="selectedDestination = destination"
                            >
                                <v-list-item-title>{{ destination }}</v-list-item-title>
                            </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>

                    <v-col cols="3" class="pr-2 ml-15">
                        <div class="split-box">
                            <div class="label-box">Supplier</div>
                            <div class="value-box">
                            {{ supplierInfo }}
                            </div>
                        </div>
                    </v-col>

                    <!-- ✅ shared 이고 username이 P1300 또는 P0801일 때만 드롭다운 -->
                    <!-- 조건부 렌더링 & 드롭다운 예 -->
                    <v-col
                        v-if="isMobisUser && category === 'Shared'"
                        cols="3"
                        class="pr-2 mb-2 ml-15 mr-2"
                    >
                    <v-menu>
                        <template v-slot:activator="{ props }">
                        <div class="split-box" v-bind="props">
                            <div class="label-box">Category</div>
                            <div class="select-box">
                            {{ categoryPlace === 'Shared' ? 'Select Category' : (categoryPlace || 'Select Category') }}
                            </div>
                        </div>
                        </template>
                        <v-list>
                        <v-list-item
                            v-for="(option, index) in ['AL', 'GA']"
                            :key="index"
                            @click="categoryPlace = option"
                        >
                            <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item>
                        </v-list>
                    </v-menu>
                    </v-col>


                    <!-- ✅ username이 P1300 또는 P0801이고 shared가 아닐 때는 읽기 전용 표시 -->
                    <v-col
                    v-else-if="isMobisUser"
                    cols="3"
                    class="pr-2 ml-15"
                    >
                    <div class="split-box">
                        <div class="label-box">Category</div>
                        <div class="value-box">
                        {{ category }}
                        </div>
                    </div>
                    </v-col>


                    
                </v-row>
            </v-card>

            <!-- ✅ PO 리스트 테이블 -->
            <v-card class="custom-card-box mb-4">
                <v-card-title class="custom-card-title">
                    Delivery Details Selection
                </v-card-title>
                <div class="d-flex align-items-center  mt-3 mb-3 ">
                <span class="ml-2 mr-6 font-weight-bold text-muted small">
                    * Select a Lot Date and click "Add" to enter the quantity.
                </span>
            </div>
                <table class="custom-table improved-table">
                <thead>
                  <tr>
                    <th>PO Number Detail</th>
                    <th>Part Number</th>
                    <th>Part Name</th>
                    <th>PO QTY</th>
                    <th>Shipped QTY</th>
                    <th>Remain QTY</th>
                    <th>Order QTY</th>
                    <th>
                        {{ !isPalletPrintCompany ? 'Departure Date' : 'Lot Date' }}
                    </th>
                    <th>Add Lot & QTY</th>
                  </tr>
                </thead>
                <tbody>
                    <!-- ✅ 기존 테이블 row -->
                    <template v-for="(item, index) in items" :key="index">
                    <tr>
                        <td :rowspan="(additionalTables[item.poDetail]?.length || 0) > 0 ? 2 : 1">
                        <strong>{{ item.poDetail }}</strong>
                        </td>
                        <td>{{ item.productName }}</td>
                        <td>{{ item.productNumber }}</td>
                        <td class="text-right">{{ formatNumber(item.orderQuantity) }}</td>
                        <td class="text-right">{{ formatNumber(item.receivedQuantity) }}</td>
                        <td class="text-right">{{ formatNumber(item.remainingQuantity) }}</td>
                        <td :class="[getOrderQtyClass(item.orderPOQuantity, item.remainingQuantity), 'text-right']">
                        {{ formatNumber(item.orderPOQuantity) }}
                        </td>
                        <td>
                        <input
                            v-if="!isPalletPrintCompany"
                            type="date"
                            v-model="masterLotDate"
                            class="lot-input"
                            :disabled="true"
                        />
                        <input
                            v-else
                            type="date"
                            v-model="item.lotDate"
                            class="lot-input"
                        />
                        </td>

                        <td>
                        <button class="add-btn" @click="handleAddLot(item.poDetail, item.lotDate)">
                            <v-icon size="18" class="mr-1">mdi-plus-circle</v-icon>Add
                        </button>
                        </td>
                    </tr>

                    <!-- ✅ 병합된 아래 줄 -->
                    <tr v-if="additionalTables[item.poDetail]?.length">
                        <td colspan="8" class="sub-table-wrapper">
                            <table class="custom-table2">
                            <thead>
                                <tr v-if="usesLotSuffixNotice">
                                <th colspan="4" style="text-align: left; padding: 8px; background-color: #fff8e1; font-weight: bold;">
                                    ※ Please add <span style="color: blue;">1</span> for day shift or <span style="color: red;">2</span> for night shift at the end of the LOT number.
                                </th>
                                </tr>
                                <tr>
                                <th>{{ !isPalletPrintCompany ? 'Date' : 'Lot DATE' }}</th>
                                <th v-if="isMobisUser">
                                    Category
                                </th>
                                <th v-if="usesShinwhaPalletLabel">
                                    Lot No
                                </th>
                                <th>QTY</th>
                                <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="(table, subIndex) in additionalTables[item.poDetail]"
                                :key="`sub-${item.poDetail}-${subIndex}`"
                                >
                                <td>
                                    <input type="date" class="lot-input" style="align-items: center;" :value="table.lotDate" readonly />
                                </td>
                                <td
                                v-if="isMobisUser"
                                style="display: flex; align-items: center; height: 61px;"
                                >
                                <input
                                    type="text"
                                    class="lot-input5"
                                    :value="categoryPlace"
                                    disabled
                                    style="flex: 1;"
                                />
                                </td>
                                <td v-if="isPalletPrintCompany" style="display: flex; align-items: center; height: 61px;">
                                    <template v-if="!isPalletPrintCompany">
                                        <input
                                            type="text"
                                            class="lot-input5"
                                            :value="categoryPlace"
                                            disabled
                                            style="flex: 1;"
                                        />
                                    </template>
                                    <template v-else>
                                        <input
                                            type="text"
                                            class="lot-input"
                                            :value="table.lotNo?.substring(0, 3)"
                                            readonly
                                            style="flex: 1;"
                                        />
                                        <input
                                            type="text"
                                            class="lot-suffix-input mt-2 mb-2"
                                            v-model="table.lotSuffix"
                                            maxlength="1"
                                            placeholder="#"
                                            style="width: 25px; text-align: center;"
                                            @input="validateLotSuffix(table)"
                                        />
                                    </template>
                                </td>
                                <td>
                                    <input
                                    type="number"
                                    class="lot-input2"
                                    v-model.number="table.quantity"
                                    placeholder="Enter QTY"
                                    @input="updateOrderPOQty(item.poDetail)"
                                    />
                                </td>
                                <td>
                                    <button class="delete-btn" @click="handleRemoveTable(item.poDetail, subIndex)">
                                    <v-icon size="18" class="mr-1">mdi-delete</v-icon>Delete
                                    </button>
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        </td>
                        </tr>
                    </template>

                </tbody>

              </table>
              
          </v-card>
        </v-container>
    </div>
    </div>
    </div>
    <v-dialog v-model="showPrintModal" max-width="700px" max-height ="300px" persistent>
      <v-card class="pa-4">
        <v-card-title class="text-h6 text-center">
             {{ !isPalletPrintCompany ? 'Packing List Print' : 'Pallet / Packing List Print' }}
        </v-card-title>
        <v-card-actions class="d-flex justify-center">
        <v-btn
            @click="printPackingList"
            color="secondary"
            >
            Packing List Print
        </v-btn>
          <!-- ✅ P3003이 아닐 때만 Pallet A4 Print 버튼 표시 -->
            <v-btn
            v-if="isPalletPrintCompany"
            @click="generatePdf"
            color="primary"
            class="mr-2"
            :disabled="!isPackingListPrinted"
            >
            Pallet A4 Print
            </v-btn>

            <!-- ✅ P3003이 아닐 때만 Pallet Label Print 버튼 표시 -->
            <v-btn
                v-if="usesPackingInfoPalletLabel"
                @click="printPalletLabel"
                color="info"
                :disabled="!isPackingListPrinted"
            >
                PALLET LABEL PRINT
            </v-btn>

            <!-- ✅ P2004 전용 버튼 추가 -->
            <v-btn
                v-else-if="usesShinwhaPalletLabel"
                @click="printPalletLabel2"
                color="info"
                :disabled="!isPackingListPrinted"
            >
                PALLET LABEL PRINT
            </v-btn>

            <!-- Packing List Print 버튼 -->
        

        

        </v-card-actions>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="grey darken-1"  @click="closeScreen(); showPrintModal = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPalletLabelModal" max-width="1300px" persistent>
        <v-card class="pa-4">
            <v-card-title class="text-h6 text-center">
                Packing Details
            </v-card-title>
            <v-card-text>
            <v-table>
                <thead>
                    <tr>
                    <th class="col-product-number">Part Number</th>
                    <th class="col-product-name">Part Name</th>
                    <th v-if="isPalletPrintCompany" class="col-lot-no">LOT No</th>
                    <th class="col-delivery-qty">Delivery QTY</th>
                    <th class="col-per-container">
                        Per Lack Quantity  
                        <br />
                        <small style="font-weight: normal; color: #888;">
                            * Quantity per container can be adjusted if different.
                        </small>
                    </th>
                    <th v-if="usesShinwhaPalletLabel" class="col-per-container">
                        Number of Copies
                    </th>

                    <th v-if="isMexicoPalletCompany" class="col-rack-qty">
                        RACK QTY
                    </th>                      
                    </tr>
                </thead>
                <tbody>
                <template v-for="(lots, poDetail) in additionalTables" :key="poDetail">
                    <tr v-for="(lot, index) in lots" :key="index" class="table-row">
                        <td class="col-product-number">{{ getProductName(poDetail) }}</td>
                        <td class="col-product-name">{{ getProductNumber(poDetail) }}</td>
                        <td v-if="isPalletPrintCompany" class="col-lot-no">
                            {{ lot.lotNo }}
                        </td>
                        <td class="col-delivery-qty">{{ formatNumber(lot.quantity) }}</td>
                        
                        <td class="col-per-container">
                            <div v-if="isMexicoPalletCompany" style="display: flex; flex-direction: column; gap: 4px;">
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.perContainer1" 
                                placeholder="Per Container 1"
                                />
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.perContainer2" 
                                placeholder="Per Container 2"
                                />
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.perContainer3" 
                                placeholder="Per Container 3"
                                />
                            </div>
                            <div v-else>
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.perContainer" 
                                placeholder="Per Container"
                                />
                            </div>
                            </td>

                            <td v-if="isMexicoPalletCompany" class="col-rack-qty">
                            <div style="display: flex; flex-direction: column; gap: 4px;">
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.rackQty1" 
                                placeholder="Rack QTY 1"
                                />
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.rackQty2" 
                                placeholder="Rack QTY 2"
                                />
                                <input 
                                type="number" 
                                class="lot-input2" 
                                v-model="lot.rackQty3" 
                                placeholder="Rack QTY 3"
                                />
                            </div>
                            </td>
                            <td v-if="usesShinwhaPalletLabel" class="col-per-container">
                                <div style="display: flex; justify-content: flex-end;">
                                    <v-select
                                        v-model="lot.copies"
                                        :items="[2, 4]"
                                        dense
                                        variant="outlined"
                                        hide-details
                                        style="max-width: 80px;"
                                        class="copies-cell"
                                    />
                                </div>
                            </td>


                    </tr>

                    <!-- <td>
                        <select class="lot-input2" v-model="lot.rackType">
                        <option value="None">None</option>
                        <option value="Returnable">Returnable</option>
                        </select>
                    </td> -->
                </template>
                </tbody>
            </v-table>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn color="primary" @click="isMexicoPalletCompany ? handlePalletPrintMexico() : handlePalletPrint()"> Confirm </v-btn>
                <v-btn color="grey darken-1" @click="showPalletLabelModal = false"> Close </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

  </template>
  
<script>
import axios from "axios";
import { mapState } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
if (pdfFonts && pdfFonts.pdfMake) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
    console.error("❌ pdfFonts가 로드되지 않았습니다.");
}

export default {
    
    props: ["po_no", "username", "location","category","departureDate"],
    
    async mounted() {
        this.items.forEach(item => {
        if (!item.subItems) {
            item.
            subItems = [];
        }
    });
        await Promise.all([
            this.fetchWarehouseNames(),
            this.fetchMobisUserList(),
            this.fetchPalletPrintCompanyList()
        ]);
        this.setDestinationFromLocation(); // location 기반으로 Destination 설정

        this.GetInvoiceIssuanceDetail(); 
        this.fetchCompanyInfo();
    },
    data() {
        return {
            boxdetail : [],
            masterLotDate: this.departureDate || "", // 💡 P1300 / P0801일 경우 사용하는 통합 lotDate
            categoryPlace: this.category,  // props 복제 (단방향 복사)
            pdfDetailsLabel: [],
            pdfDetails: [],
            pdfDetailsForMexico: [],
            isPalletPrintDisabled: false,  // Pallet Print 활성화 상태
            isPackingListDisabled: true,   // Packing List Print 기본적으로 비활성화
            printWindow: null,
            showPrintModal: false,
            showPalletLabelModal: false,
            invoiceDetails: [],
            expanded: [],
            loading: false,
            additionalTables: {},
            supplierCode: "",
            supplierInfo: "",
            selectedDestination: "", // 선택된 Destination
            isDestinationAutoSelected: false,

            destinationList: [],
            destinationCodeMap: {},
            destinationNameMap: {},
            mobisUserList: [],
            palletPrintCompanyList: [],
            palletLabelLandscapeCompanyList: [],
            items: [],
            isPackingListPrinted: false, // ✅ Packing List가 프린트 되었는지 여부

        };
    },

    // watch: {
    //     // ✅ 모든 추가된 Lot의 수량이 변경될 때 감지하여 제한 적용
    //     additionalTables: {
    //         handler(newVal) {
    //             Object.keys(newVal).forEach(poDetail => {
    //                 newVal[poDetail].forEach(lot => {
    //                     let item = this.items.find(i => i.poDetail === poDetail);
    //                     if (!item) return;
                        
    //                     let maxAllowed = item.remainingQuantity - (this.totalLotQuantity[poDetail] - Number(lot.quantity || 0));

    //                     if (Number(lot.quantity) > maxAllowed) {
    //                         lot.quantity = maxAllowed; // ✅ 초과할 경우 자동 조정
    //                     }
    //                 });
    //             });
    //         },
    //         deep: true, // ✅ 객체 내부 값까지 감시
    //         immediate: true
    //     }
    // },
    computed: {
        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        userName: (state) => state.userName, // Vuex 상태에서 username 가져오기

        }),
        // ✅ 원본 데이터 + subItems 데이터를 하나의 배열로 변환
        normalizedUsername() {
            return String(this.username || "").toUpperCase();
        },
        isMobisUser() {
            return this.mobisUserList
                .map(code => String(code).toUpperCase())
                .includes(this.normalizedUsername);
        },
        isPalletPrintCompany() {
            return this.palletPrintCompanyList
                .map(code => String(code).toUpperCase())
                .includes(this.normalizedUsername);
        },
        usesLandscapePalletLabel() {
            return this.palletLabelLandscapeCompanyList
                .map(code => String(code).toUpperCase())
                .includes(this.normalizedUsername);
        },
        usesPackingInfoPalletLabel() {
            // Legacy packing-info pallet label flow is currently unused.
            // return ["P3009", "P1309", "P0809"].includes(this.normalizedUsername);
            return false;
        },
        usesShinwhaPalletLabel() {
            return this.isPalletPrintCompany && !this.usesPackingInfoPalletLabel;
        },
        usesLotSuffixNotice() {
            // Legacy P3003 exception is currently unused.
            // return (this.isMobisUser && this.normalizedUsername !== "P3003") || this.usesShinwhaPalletLabel;
            return this.isMobisUser || this.usesShinwhaPalletLabel;
        },
        isMexicoPalletCompany() {
            // Legacy Mexico pallet flow is currently unused.
            // return this.normalizedUsername === "P3009";
            return false;
        },
        flatItems() {
            return this.items.flatMap(item => [item, ...item.subItems]);
        },
        totalLotQuantity() {
            let lotSum = {};
            Object.keys(this.additionalTables).forEach(poDetail => {
                lotSum[poDetail] = this.additionalTables[poDetail].reduce(
                    (sum, lot) => sum + Number(lot.quantity || 0),
                    0
                );
            });
            return lotSum;
        }
    },
    methods: {
        validateLotSuffix(lot) {
            if (lot.lotSuffix !== '1' && lot.lotSuffix !== '2') {
            lot.lotSuffix = ''; // 🚫 1 또는 2가 아니면 지움
            }
        },
        setDestinationFromLocation() {
            const destination = String(this.location || "").trim();
            this.selectedDestination = this.destinationNameMap[destination] || (
                this.destinationList.includes(destination) ? destination : ""
            );
            this.isDestinationAutoSelected = Boolean(this.selectedDestination);
        },
      async fetchWarehouseNames() {
            try {
                const response = await axios.get("/api/getWarehouseName");
                const rows = response.data.data || [];
                const warehouses = rows
                    .map(row => ({
                        code: String(row.ASDES || "").trim(),
                        name: String(row.AREF1 || row.ASDES || "").trim(),
                    }))
                    .filter(row => row.code && row.name);

                this.destinationList = [...new Set(warehouses.map(row => row.name))];

                this.destinationCodeMap = warehouses.reduce((map, row) => {
                    map[row.name] = row.code;
                    map[row.code] = row.code;
                    return map;
                }, {});

                this.destinationNameMap = warehouses.reduce((map, row) => {
                    map[row.code] = row.name;
                    map[row.name] = row.name;
                    return map;
                }, {});
            } catch (error) {
                console.error("getWarehouseName API 호출 오류:", error);
            }
        },
        async fetchMobisUserList() {
            try {
                const response = await axios.get("/api/getGaAlCompany");
                const rows = response.data.result || [];

                this.mobisUserList = rows
                    .map(row => String(row.ASDES || row).trim())
                    .filter(Boolean);
            } catch (error) {
                console.error("getGaAlCompany API 호출 오류:", error);
                this.mobisUserList = [];
            }
        },
        async fetchPalletPrintCompanyList() {
            try {
                const response = await axios.get("/api/getPalletPrintCompany");
                const rows = response.data.data || [];

                this.palletPrintCompanyList = rows
                    .map(row => String(row.ASDES || row.CUST_CD || row).trim())
                    .filter(Boolean);

                this.palletLabelLandscapeCompanyList = rows
                    .filter(row => String(row.USE_PALLET_LABEL_LANDSCAPE || "").trim().toUpperCase() === "Y")
                    .map(row => String(row.ASDES || row.CUST_CD || row).trim())
                    .filter(Boolean);
            } catch (error) {
                console.error("getPalletPrintCompany API 호출 오류:", error);
                this.palletPrintCompanyList = [];
                this.palletLabelLandscapeCompanyList = [];
            }
        },
        getDestinationCode() {
            const destination = String(this.selectedDestination || "").trim();
            return this.destinationCodeMap[destination] || destination || "UNKNOWN";
        },
        formatNumber(value) {
            if (!value) return "0";
            return Number(value).toLocaleString();
        },
        async printPalletLabel() {
            //console.log("📦 Pallet Label Print 실행", this.asnNo);

            try {
                // ✅ API 호출: getPackingInfoPrintLabel
                const response = await axios.get("/api/getPackingInfoPrintLabel", {
                    params: { asnNo: this.asnNo } // ✅ asnNo를 기반으로 데이터 조회
                });

                if (response.data.success) {
                    //console.log("✅ Pallet Label Print API 호출 성공");
                    //console.log("📌 받은 데이터:", response.data.packingInfo);

                    // ✅ 데이터 저장
                    this.pdfDetailsLabel = response.data.packingInfo.map(item => {
                    // ✅ BOX_LOT 날짜 형식 변환 (YYYY/MM/DD)
                    let formattedLotDate = "";
                    if (item.BOX_LOT && item.BOX_LOT.length === 8) {
                        formattedLotDate = `${item.BOX_LOT.substring(0, 4)}/${item.BOX_LOT.substring(4, 6)}/${item.BOX_LOT.substring(6, 8)}`;
                    }

                    // ✅ ITMNO 변환 로직 적용
                    let formattedPartNumber = item.ITMNO.trim();
                    if (!isNaN(parseFloat(formattedPartNumber.charAt(0))) && isFinite(formattedPartNumber.charAt(0))) {
                        formattedPartNumber = formattedPartNumber.substring(0, 5) + '-' + formattedPartNumber.substring(5);
                    } else {
                        formattedPartNumber = formattedPartNumber.substring(0, 6) + '-' + formattedPartNumber.substring(6);
                    }

                    return {
                        Part_number: formattedPartNumber, // ✅ 변환된 Part Number 적용
                        Part_name: item.ITM_NM,
                        quantity: item.BOX1_QTY,
                        lotDate: formattedLotDate, // ✅ 변환된 BOX_LOT 적용
                        SupplierName: item.CO_GB,
                        box1Qr: item.BOX1_QR // ✅ 바코드 생성을 위한 box1Qr 추가
                    };
                });

                    //console.log("📌 변환된 pdfDetailsLabel:", this.pdfDetailsLabel);

                    // ✅ 바코드 이미지 생성
                    const barcodeImages = await Promise.all(
                        this.pdfDetailsLabel.map(detail => this.generateBarcode(detail.box1Qr))
                    );

                    // ✅ 생성된 바코드 이미지 추가
                    this.pdfDetailsLabel.forEach((detail, index) => {
                        detail.barcodeImage = barcodeImages[index]; // ✅ 생성된 바코드 이미지 저장
                    });
                    //console.log("📌 바코드 이미지 생성 완료:", this.pdfDetails);

                    // ✅ PDF 생성 (generatePdf2에서 처리)
                    this.generatePdf2();
                } else {
                    console.error("❌ getPackingInfoPrintLabel 실패:", response.data.message);
                }
            } catch (error) {
                console.error("❌ getPackingInfoPrintLabel API 호출 실패:", error);
            }
        },

        async printPalletLabel2() {
            //console.log("📦 Pallet Label Print2 실행", this.asnNo);
            this.generatePdf3();
        },
        async generatePdf3() {
            //console.log("📦 Pallet Label Print 실행");
            try {
                const useLandscapePalletLabel = this.usesLandscapePalletLabel;
                const apiUrl = useLandscapePalletLabel
                ? "/api/createPalletLabelPdfForshinwhaNewVersion"
                : "/api/createPalletLabelPdf3";

                const response = await axios.post(
                apiUrl,
                { pdfDetails: this.boxdetail },
                { responseType: "blob" }
                );
                if (response.status === 200) {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = async () => {
                        const { PDFDocument, degrees } = await import("pdf-lib"); // ✅ pdf-lib 동적 로드
                        const pdfDoc = await PDFDocument.load(reader.result);
                        const pages = pdfDoc.getPages();

                        // ✅ 모든 페이지를 90도 회전
                        if (!useLandscapePalletLabel) {
                            pages.forEach((page) => {
                                page.setRotation(degrees(90));
                            });
                        }

                        // ✅ 새로운 PDF 생성
                        const rotatedPdfBytes = await pdfDoc.save();
                        const rotatedFile = new Blob([rotatedPdfBytes], { type: "application/pdf" });
                        const rotatedFileURL = URL.createObjectURL(rotatedFile);

                        const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");
                        if (newWindow) {
                            newWindow.document.write(`
                                <html>
                                <head>
                                    <title>Pallet Label Rotated</title>
                                    <style>
                                    body {
                                        margin: 0;
                                        display: flex;
                                        flex-direction: column;
                                        height: 100vh;
                                    }
                                    iframe {
                                        flex: 1;
                                        border: none;
                                        width: 100%;
                                    }
                                    button {
                                        padding: 10px 20px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        background-color: #28a745;
                                        color: white;
                                        border: none;
                                        cursor: pointer;
                                        margin: 10px;
                                    }
                                    </style>
                                </head>
                                <body>
                                    <iframe src="${rotatedFileURL}"></iframe>
                                </body>
                                </html>
                            `);
                            } else {
                            alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                            }
                        };
                    this.loading = false;
                } else {
                    console.error("❌ Pallet Label PDF 생성 실패:", response.status);
                    this.loading = false;

                }
            } catch (error) {
                console.error("❌ Pallet Label Print API 호출 실패:", error);
                this.loading = false;

            }
        },
        async generatePdf2() {
            //console.log("📦 Pallet Label Print 실행");
            try {
                const response = await axios.post(
                    "/api/createPalletLabelPdf3",
                    { pdfDetails: this.pdfDetailsLabel },
                    { responseType: "blob" }
                );
                if (response.status === 200) {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = async () => {
                        const { PDFDocument, degrees } = await import("pdf-lib"); // ✅ pdf-lib 동적 로드
                        const pdfDoc = await PDFDocument.load(reader.result);
                        const pages = pdfDoc.getPages();

                        // ✅ 모든 페이지를 90도 회전
                        pages.forEach((page) => {
                            page.setRotation(degrees(90));
                        });

                        // ✅ 새로운 PDF 생성
                        const rotatedPdfBytes = await pdfDoc.save();
                        const rotatedFile = new Blob([rotatedPdfBytes], { type: "application/pdf" });
                        const rotatedFileURL = URL.createObjectURL(rotatedFile);

                        const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");
                        if (newWindow) {
                            newWindow.document.write(`
                                <html>
                                <head>
                                    <title>Pallet Label Rotated</title>
                                    <style>
                                    body {
                                        margin: 0;
                                        display: flex;
                                        flex-direction: column;
                                        height: 100vh;
                                    }
                                    iframe {
                                        flex: 1;
                                        border: none;
                                        width: 100%;
                                    }
                                    button {
                                        padding: 10px 20px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        background-color: #28a745;
                                        color: white;
                                        border: none;
                                        cursor: pointer;
                                        margin: 10px;
                                    }
                                    </style>
                                </head>
                                <body>
                                    <iframe src="${rotatedFileURL}"></iframe>
                                </body>
                                </html>
                            `);
                            } else {
                            alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                            }
                        };
                    this.loading = false;
                } else {
                    console.error("❌ Pallet Label PDF 생성 실패:", response.status);
                    this.loading = false;

                }
            } catch (error) {
                console.error("❌ Pallet Label Print API 호출 실패:", error);
                this.loading = false;

            }
        },
        getOrderQtyClass(orderQty, remainQty) {
            if (orderQty > remainQty) {
                return 'red-text'; // 🔴 Order Quantity가 더 크면 빨간색
            } else {
                return 'blue-text'; // 🔵 Order Quantity가 더 작거나 같으면 파란색
            }
        },
        async generateBarcode(text) {
            this.loading = true;

            try {
                if (!text) {
                    console.warn("⚠️ 바코드 데이터가 없습니다.");
                    return null;
                }

                //console.log("📌 바코드 생성 요청 중:", text);

                const response = await axios.post("/api/generateBarcode", { text });

                if (response.data.success) {
                    //console.log("✅ 바코드 생성 성공");
                    return response.data.barcode; // ✅ Base64 이미지 반환
                } else {
                    console.error("❌ 바코드 생성 실패:", response.data.message);
                    this.loading = false;

                    return null;
                }
            } catch (error) {
                console.error("❌ API 요청 중 오류 발생:", error);
                this.loading = false;

                return null;
            }
        },

        async handlePalletPrint( ) {
            this.loading = true;
            if (this.isPalletPrintDisabled) {
                alert("If you want to modify or reprint, please print from the Packing List history.");
                this.loading = false;
                return;
            }

            this.isPackingListDisabled = true; 

            const insertASNDETAIL = [];

           // ✅ Per Container 값이 0인지 검사
           for (const [poDetail, lots] of Object.entries(this.additionalTables)) {
                for (const lot of lots) {
                    if (!lot.perContainer || Number(lot.perContainer) <= 0) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - "Per Container" cannot be 0. Please enter a valid number.`);
                        this.loading = false;
                        return;
                    }
                }
            }
            

            Object.keys(this.additionalTables).forEach(poDetail => {
                const item = this.items.find(i => i.poDetail === poDetail);
                if (item) {
                    this.additionalTables[poDetail].forEach(lot => {
                        insertASNDETAIL.push({
                            poDetail,
                            lotDate: lot.lotDate,
                            lotNo: lot.lotNo,
                            quantity: lot.quantity,
                            perContainer: lot.perContainer,
                            perContainer1: lot.perConainer,
                            supplierName: this.supplierName,
                            supplierCode: this.supplierCode,
                            rackType: lot.rackType,
                            part_number: item.productName,
                            part_name: item.productNumber,   
                            categoryPlace: this.categoryPlace,   
                            destination: this.getDestinationCode() ? this.getDestinationCode()
                                        : "UNKNOWN" // ✅ 혹시 모를 예외 처리
                        });
                    });
                }
            });

            //console.log("📌 백엔드로 보낼 데이터1:", insertASNDETAIL);

            try {
                const updateResponse = await axios.post("/api/updateBPoDetail", {
                    data: insertASNDETAIL
                });

                if (updateResponse.data.success) {
                    //console.log("✅ updateBPoDetail API 호출 성공");
                } else {
                    console.error("❌ updateBPoDetail 실패:", updateResponse.data.message);
                    this.loading = false;
                    return;
                }
            } catch (error) {
                console.error("❌ updateBPoDetail API 호출 실패:", error);
                this.loading = false;
                return; // 오류 발생 시 이후 동작 중단
            }
            //console.log("📌 백엔드로 보낼 데이터2:", insertASNDETAIL);
            //✅ 백엔드 API 호출
            try {
                // ✅ 첫 번째 요청: insertASNDETAIL 호출 후 ASN_NO 받기
                const response = await axios.post("/api/insertASNDETAIL", {
                    data: insertASNDETAIL
                });

                if (response.data.success) {
                    //console.log("✅ 백엔드로 데이터 전송 성공, ASN_NO:", response.data.asnNo);
                    this.asnNo = response.data.asnNo; // ✅ 받은 ASN_NO 저장
                } else {
                    console.error("❌ insertASNDETAIL 실패:", response.data.message);
                    this.loading = false;

                    return;
                }
            } catch (error) {
                console.error("❌ insertASNDETAIL API 호출 실패:", error);
                this.loading = false;

                return; // 오류 발생 시 이후 동작 중단
            }
            this.pdfDetails = [];
            Object.keys(this.additionalTables).forEach(poDetail => {
                const item = this.items.find(i => i.poDetail === poDetail);
                if (item) {
                    this.additionalTables[poDetail].forEach(lot => {
                        if (this.isMexicoPalletCompany) {
                            // 💡 그대로 한 줄만 push
                            this.pdfDetails.push({
                                Part_number: item.productName,
                                Part_name: item.productNumber,
                                quantity: lot.quantity, // 전체 수량 그대로 넣음
                                lotDate: lot.lotDate,
                                lotNo: lot.lotNo,
                                SupplierName: this.supplierName,
                                SupplierCode : this.supplierInfo,
                                CUST_CD : this.supplierCode,
                                po_no_dtl: poDetail,
                                ASN_NO: this.asnNo 
                            });
                        }else if (this.isMobisUser){
                            this.pdfDetails.push({
                                Part_number: item.productName,
                                Part_name: item.productNumber,
                                quantity: lot.quantity, // 전체 수량 그대로 넣음
                                lotDate: lot.lotDate,
                                lotNo: lot.lotNo,
                                SupplierName: this.supplierName,
                                SupplierCode : this.supplierInfo,
                                CUST_CD : this.supplierCode,
                                po_no_dtl: poDetail,
                                ASN_NO: this.asnNo 
                            });
                        }
                        else if (this.usesShinwhaPalletLabel){
                            this.pdfDetails.push({
                                Part_number: item.productName,
                                Part_name: item.productNumber,
                                quantity: lot.quantity, // 전체 수량 그대로 넣음
                                lotDate: lot.lotDate,
                                lotNo: lot.lotNo,
                                SupplierName: this.supplierName,
                                SupplierCode : this.supplierInfo,
                                CUST_CD : this.supplierCode,
                                po_no_dtl: poDetail,
                                ASN_NO: this.asnNo 
                            });
                            let remainingQty = lot.quantity;
                            const perContainer = lot.perContainer || 1;
                            while (remainingQty > 0) {
                                this.pdfDetailsForMexico.push({
                                    Part_number: item.productName,
                                    Part_name: item.productNumber,
                                    quantity: Math.min(perContainer, remainingQty),
                                    lotDate: lot.lotDate,
                                    lotNo: lot.lotNo,
                                    copies: lot.copies,
                                    SupplierName: this.supplierName,
                                    SupplierCode : this.supplierInfo,
                                    CUST_CD : this.supplierCode,
                                    po_no_dtl: poDetail,
                                    ASN_NO: this.asnNo 
                                });
                                remainingQty -= perContainer;
                            }                      
                        }  
                        else if (!this.isMobisUser){
                            this.pdfDetails.push({
                                Part_number: item.productName,
                                Part_name: item.productNumber,
                                quantity: lot.quantity, // 전체 수량 그대로 넣음
                                lotDate: lot.lotDate,
                                lotNo: lot.lotNo,
                                SupplierName: this.supplierName,
                                SupplierCode : this.supplierInfo,
                                CUST_CD : this.supplierCode,
                                po_no_dtl: poDetail,
                                ASN_NO: this.asnNo 
                            });
                        } 
                        else {
                            let remainingQty = lot.quantity;
                            const perContainer = lot.perContainer || 1;
                            while (remainingQty > 0) {
                                this.pdfDetails.push({
                                Part_number: item.productName,
                                Part_name: item.productNumber,
                                quantity: Math.min(perContainer, remainingQty),
                                lotDate: lot.lotDate,
                                lotNo: lot.lotNo,
                                SupplierName: this.supplierName,
                                SupplierCode : this.supplierInfo,
                                CUST_CD : this.supplierCode,
                                po_no_dtl: poDetail,
                                ASN_NO: this.asnNo 
                                });
                                remainingQty -= perContainer;
                            }
                        }
                    });
                }
            });

            //console.log("📌 백엔드로 보낼 데이터3:", this.pdfDetails);
            try {
                const response = await axios.post("/api/insertMatPackingInfo", {
                    data: this.pdfDetails
                });

                //console.log("✅ insertMatPackingInfo API 호출 성공");

                // ✅ box1QrList 받아오기
                const box1QrList = response.data.box1QrList;
                //console.log("📌 받은 BOX1_QR 리스트:", box1QrList);

                // ✅ box1QrList를 pdfDetails에 추가 (barcode 생성용)
                this.pdfDetails.forEach((detail, index) => {
                    detail.box1Qr = box1QrList[index] || ""; // 리스트 개수가 다를 경우 대비
                });
                

            } catch (error) {
                console.error("❌ insertMatPackingInfo API 호출 실패:", error);
                this.loading = false;

                return;
            }
            //console.log(this.pdfDetailsForMexico, this.username, this.userName)
            if (this.usesShinwhaPalletLabel) {

                try {
                    const response = await axios.post("/api/insertMatBarcodeHis", {
                        data: this.pdfDetailsForMexico,
                        username : this.username,
                        userName: this.userName
                    });

                    //console.log("✅ insertMatBarcodeHis API 호출 성공");

                    // ✅ box1QrList 받아오기
                    this.boxdetail = response.data.enrichedDetails;

                } catch (error) {
                    console.error("❌ insertMatBarcodeHis API 호출 실패:", error);
                    this.loading = false;

                    return;
                }

                //console.log("📌 [Print 버튼 클릭] 현재 데이터:", this.pdfDetails);

                // ✅ boxdetail 에 담긴 리스트 사용해서 generateBarcode 호출
                const barcodeImages = await Promise.all(
                    this.boxdetail.map(detail => this.generateBarcode(detail.box1Qr))
                );

                // ✅ 생성된 바코드 이미지 추가
                this.boxdetail.forEach((detail, index) => {
                    detail.barcodeImage = barcodeImages[index]; // ✅ boxdetail 배열에 저장
                });
            }

            //console.log("📌 최종 boxdetail with barcodeImage:", this.boxdetail);

            // ✅ PDF 생성
            this.showPrintModal = true; // ✅ OK 누르면 진행
            this.showPalletLabelModal = false;
            this.loading = false;  
        },

        async handlePalletPrintMexico( ) {
            this.loading = true;

            //console.log('here', this.additionalTables)
            if (this.isPalletPrintDisabled) {
                alert("If you want to modify or reprint, please print from the Packing List history.");
                this.loading = false;
                return;
            }

            this.isPackingListDisabled = true; 

            const insertASNDETAIL = [];

           // ✅ Per Container 값이 0인지 검사
           for (const [poDetail, lots] of Object.entries(this.additionalTables)) {
                for (const lot of lots) {
                    const per1 = Number(lot.perContainer1) || 0;
                    const per2 = Number(lot.perContainer2) || 0;
                    const per3 = Number(lot.perContainer3) || 0;

                    const rack1 = Number(lot.rackQty1) || 0;
                    const rack2 = Number(lot.rackQty2) || 0;
                    const rack3 = Number(lot.rackQty3) || 0;

                    if (per1 === 0 && per2 === 0 && per3 === 0) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - At least one Per Container must be entered.`);
                        this.loading = false;
                        return;
                    }

                    if (per1 > 0 && rack1 === 0) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Rack QTY 1 must be entered.`);
                        this.loading = false;
                        return;
                    }

                    if (per2 > 0 && rack2 === 0) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Rack QTY 2 must be entered.`);
                        this.loading = false;
                        return;
                    }

                    if (per3 > 0 && rack3 === 0) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Rack QTY 3 must be entered.`);
                        this.loading = false;
                        return;
                    }

                    const totalCalculatedQty = (per1 * rack1) + (per2 * rack2) + (per3 * rack3);

                    if (totalCalculatedQty !== Number(lot.quantity)) {
                        alert(`🚨 PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Total calculated quantity (${totalCalculatedQty}) does not match entered quantity (${lot.quantity}).`);
                        this.loading = false;
                        return;
                    }
                }
            }

            Object.keys(this.additionalTables).forEach(poDetail => {
                const item = this.items.find(i => i.poDetail === poDetail);
                if (item) {
                    this.additionalTables[poDetail].forEach(lot => {
                        const entries = [
                            { perContainer: Number(lot.perContainer1) || 0, rackQty: Number(lot.rackQty1) || 0 },
                            { perContainer: Number(lot.perContainer2) || 0, rackQty: Number(lot.rackQty2) || 0 },
                            { perContainer: Number(lot.perContainer3) || 0, rackQty: Number(lot.rackQty3) || 0 },
                        ];

                        entries.forEach((entry) => {
                            if (entry.perContainer > 0 && entry.rackQty > 0) {
                                insertASNDETAIL.push({
                                    poDetail,
                                    lotDate: lot.lotDate,
                                    lotNo: lot.lotNo,
                                    quantity: entry.perContainer * entry.rackQty,
                                    perContainer: entry.perContainer,
                                    supplierName: this.supplierName,
                                    supplierCode: this.supplierCode,
                                    rackType: lot.rackType,
                                    part_number: item.productName,
                                    part_name: item.productNumber,
                                    destination: this.getDestinationCode() ? this.getDestinationCode()
                                        : "UNKNOWN"
                                });
                            } else {
                                //console.log(`⚠️ Skipped perContainer${idx + 1} or rackQty${idx + 1} is 0 or empty.`);
                            }
                        });
                    });
                }
            });

            //console.log("📌 백엔드로 보낼 데이터1:", insertASNDETAIL);

            
            try {
                const updateResponse = await axios.post("/api/updateBPoDetail", {
                    data: insertASNDETAIL
                });

                if (updateResponse.data.success) {
                    //console.log("✅ updateBPoDetail API 호출 성공");
                } else {
                    console.error("❌ updateBPoDetail 실패:", updateResponse.data.message);
                    this.loading = false;
                    return;
                }
            } catch (error) {
                console.error("❌ updateBPoDetail API 호출 실패:", error);
                this.loading = false;
                return; // 오류 발생 시 이후 동작 중단
            }
            //console.log("📌 백엔드로 보낼 데이터2:", insertASNDETAIL);
            //✅ 백엔드 API 호출
            try {
                // ✅ 첫 번째 요청: insertASNDETAIL 호출 후 ASN_NO 받기
                const response = await axios.post("/api/insertASNDETAIL", {
                    data: insertASNDETAIL
                });

                if (response.data.success) {
                    //console.log("✅ 백엔드로 데이터 전송 성공, ASN_NO:", response.data.asnNo);
                    this.asnNo = response.data.asnNo; // ✅ 받은 ASN_NO 저장
                } else {
                    console.error("❌ insertASNDETAIL 실패:", response.data.message);
                    this.loading = false;

                    return;
                }
            } catch (error) {
                console.error("❌ insertASNDETAIL API 호출 실패:", error);
                this.loading = false;

                return; // 오류 발생 시 이후 동작 중단
            }
            this.pdfDetails = [];
            Object.keys(this.additionalTables).forEach(poDetail => {
                const item = this.items.find(i => i.poDetail === poDetail);
                if (item) {
                    this.additionalTables[poDetail].forEach(lot => {
                        const entries = [
                            { perContainer: Number(lot.perContainer1) || 0, rackQty: Number(lot.rackQty1) || 0 },
                            { perContainer: Number(lot.perContainer2) || 0, rackQty: Number(lot.rackQty2) || 0 },
                            { perContainer: Number(lot.perContainer3) || 0, rackQty: Number(lot.rackQty3) || 0 },
                        ];

                        entries.forEach((entry) => {
                            if (entry.perContainer > 0 && entry.rackQty > 0) {
                                for (let i = 0; i < entry.rackQty; i++) {
                                    this.pdfDetails.push({
                                        Part_number: item.productName,
                                        Part_name: item.productNumber,
                                        quantity: entry.perContainer,
                                        lotDate: lot.lotDate,
                                        lotNo: lot.lotNo,
                                        SupplierName: this.supplierName,
                                        SupplierCode: this.supplierInfo,
                                        CUST_CD: this.supplierCode,
                                        po_no_dtl: poDetail,
                                        ASN_NO: this.asnNo
                                    });
                                }
                            }
                        });
                    });
                }
            });

            //console.log("📌 백엔드로 보낼 데이터3:", this.pdfDetails);
            try {
                const response = await axios.post("/api/insertMatPackingInfo", {
                    data: this.pdfDetails
                });

                //console.log("✅ insertMatPackingInfo API 호출 성공");

                // ✅ box1QrList 받아오기
                const box1QrList = response.data.box1QrList;
                //console.log("📌 받은 BOX1_QR 리스트:", box1QrList);

                // ✅ box1QrList를 pdfDetails에 추가 (barcode 생성용)
                this.pdfDetails.forEach((detail, index) => {
                    detail.box1Qr = box1QrList[index] || ""; // 리스트 개수가 다를 경우 대비
                });

            } catch (error) {
                console.error("❌ insertMatPackingInfo API 호출 실패:", error);
                this.loading = false;

                return;
            }

            //console.log("📌 [Print 버튼 클릭] 현재 데이터:", this.pdfDetails);

            // ✅ 바코드 이미지 생성 (box1Qr 사용)
            const barcodeImages = await Promise.all(
                 this.pdfDetails.map(detail => this.generateBarcode(detail.box1Qr))
            );

            // ✅ 생성된 바코드 이미지 추가
            this.pdfDetails.forEach((detail, index) => {
                detail.barcodeImage = barcodeImages[index]; // ✅ 생성된 바코드 이미지 저장
            });

            // ✅ PDF 생성
            this.showPrintModal = true; // ✅ OK 누르면 진행
            this.showPalletLabelModal = false;
            this.loading = false;  
        },

        async generatePdf() {
            //console.log("📦 Pallet Label Print 실행");
            try {
                const requestData = {
                    pdfDetails: this.boxdetail // 기존에 사용하던 데이터 그대로 넘기기
                };

                const response = await axios.post("/api/createPalletLabelPdf", requestData, {
                    responseType: "blob" // ✅ PDF 파일 Blob으로 받음
                });

                if (response.status === 200) {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");

                    if (newWindow) {
                        newWindow.document.write(`
                        <html>
                            <head>
                            <title>Pallet Label Preview</title>
                            <style>
                                body {
                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                height: 100vh;
                                }
                                iframe {
                                flex: 1;
                                border: none;
                                width: 100%;
                                }
                                button {
                                padding: 10px 20px;
                                font-size: 16px;
                                font-weight: bold;
                                background-color: #007bff;
                                color: white;
                                border: none;
                                cursor: pointer;
                                margin: 10px;
                                }
                            </style>
                            </head>
                            <body>
                            <iframe src="${fileURL}"></iframe>
                            </body>
                        </html>
                        `);
                    } else {
                        alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                    }
                    this.isPackingListDisabled = false; 
                    this.isPalletPrintDisabled = true;
                    this.showPalletLabelModal = false;
                } else {
                    console.error("❌ Pallet Label PDF 생성 실패:", response.status);
                }
            } catch (error) {
                console.error("❌ Pallet Label Print API 호출 실패:", error);
            }
        },


        // generatePdf() {
        //     //console.log("📌 PDF 생성 시작");
        //     //console.log(this.pdfDetails)
            
        //     const docDefinition = {
        //         content: this.pdfDetails.map((detail, index, array) => {
        //             // ✅ box1Qr 값에서 :3S 뒤와 :V 사이 값 추출
        //             let handlingUnit = "N/A"; // 기본값 (데이터 없을 경우 대비)
        //             if (detail.box1Qr) {
        //                 const match = detail.box1Qr.match(/:3S(.*?):V/);
        //                 //console.log("📌 PDF 생성 시작1");
        //                 //console.log(match);
        //                 //console.log(match[1]);
        //                 if (match && match[1]) {
        //                     handlingUnit = match[1]; // 추출된 값
        //                 }
        //             }
        //             //console.log("📌 PDF 생성 시작2");
        //             //console.log(handlingUnit);

        //             return {
        //                 stack: [
        //                     {
        //                         canvas: [
        //                             { type: "rect", x: 0, y: 0, w: 520, h: 350, r: 5, lineColor: "black" }, // ✅ 라벨 테두리
        //                             { type: "line", x1: 10, y1: 100, x2: 510, y2: 100, lineWidth: 1 }, // ✅ 구분선 1
        //                             { type: "line", x1: 10, y1: 160, x2: 510, y2: 160, lineWidth: 1 }, // ✅ 구분선 2
        //                             { type: "line", x1: 10, y1: 220, x2: 510, y2: 220, lineWidth: 1 }, // ✅ 구분선 3
        //                             { type: "line", x1: 10, y1: 280, x2: 200, y2: 280, lineWidth: 1 }, // ✅ 구분선 4
        //                             { type: "line", x1: 250, y1: 160, x2: 250, y2: 220, lineWidth: 1 }, // ✅ 구분선 5
        //                             { type: "line", x1: 200, y1: 220, x2: 200, y2: 340, lineWidth: 1 }, // ✅ 구분선 6
                                
        //                             { type: "rect", x: 0, y: 375, w: 520, h: 350, r: 5, lineColor: "black" }, // ✅ 라벨 테두리
        //                             { type: "line", x1: 10, y1: 475, x2: 510, y2: 475, lineWidth: 1 }, // ✅ 구분선 1
        //                             { type: "line", x1: 10, y1: 535, x2: 510, y2: 535, lineWidth: 1 }, // ✅ 구분선 2
        //                             { type: "line", x1: 10, y1: 595, x2: 510, y2: 595, lineWidth: 1 }, // ✅ 구분선 3
        //                             { type: "line", x1: 10, y1: 655, x2: 200, y2: 655, lineWidth: 1 }, // ✅ 구분선 4
        //                             { type: "line", x1: 250, y1: 535, x2: 250, y2: 595, lineWidth: 1 }, // ✅ 구분선 5
        //                             { type: "line", x1: 200, y1: 595, x2: 200, y2: 715, lineWidth: 1 }, // ✅ 구분선 6
        //                         ]
        //                     },
        //                     { text: "Part Number", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 50 } },
        //                     { text: detail.Part_number, fontSize: 45, bold: true, absolutePosition: { x: 150, y: 70 } },

        //                     { text: "Description", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 150 } },
        //                     { text: detail.Part_name, fontSize: 33, absolutePosition: { x: 130, y: 148 } },

        //                     { text: "Supplier", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 210 } },
        //                     { text: detail.SupplierName, fontSize: 13, bold: true, absolutePosition: { x: 110, y: 230 } },

        //                     { text: "Handling Unit", fontSize: 12, bold: true, absolutePosition: { x: 300, y: 210 } },
        //                     { text: handlingUnit, fontSize: 12, bold: true, absolutePosition: { x: 360, y: 235 } }, // ✅ box1Qr에서 추출한 값 삽입

        //                     { text: "Quantity", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 270 } },
        //                     { text: detail.quantity, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 290 } },

        //                     { text: "Manufactured Date", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 330 } },
        //                     { text: detail.lotDate, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 350 } },

        //                     { text: "Broadcast Code", fontSize: 12, bold: true, absolutePosition: { x: 250, y: 270 } },
        //                     {
        //                         image: detail.barcodeImage, // ✅ 생성된 바코드 이미지 적용
        //                         width: 300,
        //                         height: 80,
        //                         absolutePosition: { x: 250, y: 300 }
        //                     },

        //                     { text: "Part Number", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 425 } },
        //                     { text: detail.Part_number, fontSize: 45, bold: true, absolutePosition: { x: 150, y: 445 } },

        //                     { text: "Description", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 525 } },
        //                     { text: detail.Part_name, fontSize: 33, absolutePosition: { x: 130, y: 523 } },

        //                     { text: "Supplier", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 585 } },
        //                     { text: detail.SupplierName, fontSize: 13, bold: true, absolutePosition: { x: 110, y: 605 } },

        //                     { text: "Handling Unit", fontSize: 12, bold: true, absolutePosition: { x: 300, y: 585 } },
        //                     { text: handlingUnit, fontSize: 12, bold: true, absolutePosition: { x: 360, y: 610 } }, // ✅ box1Qr에서 추출한 값 삽입

        //                     { text: "Quantity", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 645 } },
        //                     { text: detail.quantity, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 665 } },

        //                     { text: "Manufactured Date", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 705 } },
        //                     { text: detail.lotDate, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 725 } },

        //                     { text: "Broadcast Code", fontSize: 12, bold: true, absolutePosition: { x: 250, y: 645 } },
        //                     {
        //                         image: detail.barcodeImage, // ✅ 생성된 바코드 이미지 적용
        //                         width: 300,
        //                         height: 80,
        //                         absolutePosition: { x: 250, y: 675 }
        //                     }

        //                 ],
        //                 pageBreak: index < array.length - 1 ? 'after' : undefined 
        //             };
        //         }),
        //         defaultStyle: {
        //             fontSize: 12
        //         }
        //     };

        //     try {
        //         // ✅ PDF 미리보기 (다운로드X, 새 창에서 열기)
        //         pdfMake.createPdf(docDefinition).open();
        //         this.isPackingListDisabled = false;  // Packing List Print 활성화
        //         this.isPalletPrintDisabled = true; 
        //         this.showPalletLabelModal = false;
        //     } catch (error) {
        //         console.error("❌ PDF 미리보기 중 오류 발생:", error);
        //     }
        // },
  
        
        getProductNumber(poDetail) {
            const item = this.items.find(i => i.poDetail === poDetail);
            return item ? item.productNumber : "";
        },

        getProductName(poDetail) {
            const item = this.items.find(i => i.poDetail === poDetail);
            return item ? item.productName : "";
        },
        getPalletQty(poDetail) {
            const item = this.items.find(i => i.poDetail === poDetail);
            return item ? item.PAL_QTY : ""; // 기본값으로 PAL_QTY 설정
        },
        async fetchCompanyInfo() {
            try {
                const response = await axios.get("/api/getCompanyInfo", {
                    params: { username: this.username }
                });

                if (response.data.success) {
                            //console.log('hi', this.departureDate)

                    //console.log("✅ 회사 정보:", response.data);
                    const data = response.data.companyName;
                    this.supplierInfo = `${data.CUST_CD} / ${data.CUST_NM}`; // ✅ CUST_CD / CUST_NM 표시
                    this.supplierName = data.CUST_NM;
                    this.supplierCode = data.CUST_CD;
                    //console.log("✅ 회사 정보:", this.supplierInfo);
                } else {
                    console.error("❌ 회사 정보를 가져오지 못했습니다.");
                    return null;
                }
            } catch (error) {
                console.error("❌ API 요청 중 오류 발생:", error);
                return null;
            }
        },
        async GetInvoiceIssuanceDetail() {
            if (!this.po_no || this.po_no.length === 0) {
                console.error("❌ No PO Number Details provided.");
                return;
            }
            if (!this.isPalletPrintCompany) {
                    this.masterLotDate = this.departureDate; // 마스터 날짜 기본값 설정
                }
            this.loading = true; // ✅ 로딩 시작
            try {
                //console.log("📌 Sending PO Numbers to API:", this.po_no);

                // ✅ API 호출 (POST 방식)
                const response = await axios.post("/api/getInvoiceIssuanceDetail", {
                    poNumbers: this.po_no, // ✅ 선택된 PO Number Detail 리스트 전달
                });

                if (response.data.success) {
                    //console.log("✅ API Response:", response.data.details);
                    const today = new Date();
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, '0');
                    const dd = String(today.getDate()).padStart(2, '0');
                    const todayStr = `${yyyy}-${mm}-${dd}`;
                    // ✅ 데이터 매핑 후 `items`에 저장
                    this.items = response.data.details.map(detail => ({
                        poDetail: detail.PO_NO_DTL,  // ✅ PO Number Detail
                        productNumber: detail.ITEM_NM,  // ✅ Product Number
                        productName: detail.ITEM_NO,  // ✅ Product Name
                        orderQuantity: detail.PO_QTY,  // ✅ Order Quantity
                        receivedQuantity: detail.RP_QTY,  // ✅ Received Quantity
                        remainingQuantity: detail.PO_QTY - detail.RP_QTY,  // ✅ Remaining Quantity
                        orderPOQuantity: 0,
                        lotDate: todayStr,  // ✅ 초기값 설정
                        PAL_QTY: detail.FINAL_PAL_QTY ?? detail.PAL_QTY,
                    }));
                    if (!this.isPalletPrintCompany) {
                        this.items.forEach(item => {
                            item.lotDate = this.departureDate;
                        });
                    }
                    //console.log("✅ Transformed Data:", this.items);
                } else {
                    console.error("❌ Failed to fetch invoice details");
                    this.items = [];
                }
            } catch (error) {
                console.error("❌ API 요청 중 오류 발생:", error);
            } finally {
                this.loading = false; // ✅ 로딩 종료
            }
        },
        translateToLot(lotDate) {
            const date = new Date(lotDate);
            const year = date.getFullYear().toString();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");

            const yearMap = {
                "2022": "V", "2023": "W", "2024": "X", "2025": "Y", "2026": "Z", "2027": "2"
            };
            const monthMap = {
                "01": "A", "02": "B", "03": "C", "04": "D", "05": "E", "06": "F",
                "07": "G", "08": "H", "09": "I", "10": "J", "11": "K", "12": "L"
            };
            const dayMap = {
                "01": "A", "02": "B", "03": "C", "04": "D", "05": "E", "06": "F", "07": "G",
                "08": "H", "09": "I", "10": "J", "11": "K", "12": "L", "13": "M", "14": "N",
                "15": "O", "16": "P", "17": "Q", "18": "R", "19": "S", "20": "T", "21": "U",
                "22": "V", "23": "W", "24": "X", "25": "Y", "26": "Z", "27": "2", "28": "3",
                "29": "4", "30": "5", "31": "6"
            };

            return `${yearMap[year] || year}${monthMap[month] || month}${dayMap[day] || day}`;
        },

        handleConfirm() {
            if (this.isMobisUser && this.categoryPlace === 'Shared') {
                alert("⚠️ You must select a category. 'Shared' is not allowed. Please choose a valid category.");
                return;
            }
            if (this.selectedDestination == '') {
                alert("Please select destination"); // 🚨 Destination 선택 안 했을 때 경고창
                return;
            }
            //console.log("✅ Confirm 버튼 클릭됨!");
            //console.log("📌 추가된 Lot 정보:", this.additionalTables);
            const missingPoDetails = this.items
                .map(item => item.poDetail)
                .filter(poDetail => !this.additionalTables[poDetail] || this.additionalTables[poDetail].length === 0);

            if (missingPoDetails.length > 0) {
                alert(`⚠️ Missing Lot Information! Please add at least one lot for PO Details: ${missingPoDetails.join(", ")}`);
                return; // 🚨 오류 발생 시 즉시 종료
            }
            for (const [poDetail, lots] of Object.entries(this.additionalTables)) {
                let totalQuantity = 0;
                
                for (const lot of lots) {

                    if (!lot.quantity || isNaN(lot.quantity) || Number(lot.quantity) < 1) {
                        alert(`⚠️ PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Quantity must be greater than 0. Please enter a valid quantity.`);
                        return; // 🚨 오류 발생 시 즉시 종료
                    }
                    //console.log(this.username)
                    if (this.isPalletPrintCompany) {
                        if (!lot.lotSuffix || (lot.lotSuffix !== '1' && lot.lotSuffix !== '2')) {
                            alert(`⚠️ PO Detail: ${poDetail}, Lot No: ${lot.lotNo} - Please enter '1' or '2' for shift info.`);
                            return;
                        }
                    }

                    totalQuantity += Number(lot.quantity);
                }

                // ✅ 해당 PO Detail의 remainQuantity 값 가져오기
                const item = this.items.find(i => i.poDetail === poDetail);
                if (!item) continue;

                if (totalQuantity > item.remainingQuantity) {
                    alert(`🚨 PO Detail: ${poDetail} - Total quantity (${totalQuantity}) exceeds the remaining quantity (${item.remainingQuantity}). Please adjust.`);
                    return; // 🚨 오류 발생 시 즉시 종료
                }
            }
            //console.log("📌 Final Lot Data:", this.additionalTables);
            // ✅ LOT DATE 일관성 검사 (P1300 또는 P0801일 때만)
            if (!this.isPalletPrintCompany) {
                const allLotDates = Object.values(this.additionalTables)
                    .flat()
                    .map(lot => lot.lotDate);

                const uniqueDates = new Set(allLotDates);

                if (uniqueDates.size > 1) {
                    alert("🚨 All Departure Dates must be the same.");
                    return;
                }
            }
             // ✅ 경고창 추가 (확인 후 진행)
            if (confirm("Are you sure all entered values are correct? Is it okay to proceed?")) {
                for (const lots of Object.values(this.additionalTables)) {
                    for (const lot of lots) {
                        if (lot.lotSuffix) {
                            // ✅ lotNo는 변경하지만 originalLotNo는 건드리지 않음
                            lot.lotNo = lot.originalLotNo + lot.lotSuffix;
                        } else {
                            lot.lotNo = lot.originalLotNo; // suffix 없으면 그냥 원본
                        }
                    }
                }

                //console.log("📌 Final Lot Data:", this.additionalTables);
                this.printPallet();
            } else {
                //console.log("❌ 사용자가 진행 취소함");
            }
        },
        printPallet() {
            if (this.isPalletPrintDisabled) {
                alert("If you want to modify or reprint, please print from the Packing List history.");
                this.loading = false;
                return;
            }
            //console.log("📦 Pallet Label Print 클릭됨");

            // ✅ additionalTables을 순회하면서 PAL_QTY 값 설정
            Object.keys(this.additionalTables).forEach(poDetail => {
                let item = this.items.find(i => i.poDetail === poDetail);
                if (item) {
                    this.additionalTables[poDetail].forEach(lot => {
                        lot.perContainer1 = item.PAL_QTY || 0;
                        lot.perContainer = item.PAL_QTY || 0; // ✅ 기본값 설정
                        lot.rackQty1 = Math.ceil((lot.quantity || 0) / (lot.perContainer1 || 1));
                        lot.rackQty2 = 0;
                        lot.rackQty3 = 0;
                    });
                }
            });

            //console.log("📌 Updated additionalTables with PAL_QTY:", this.additionalTables);
            this.showPalletLabelModal = true; // Pallet 모달 열기
        },

        // ✅ Packing List Print 버튼 클릭 시 실행
        async printPackingList() {
            //console.log("📃 Packing List Print 실행");
            

            try {

                const packingListResponse = await this.getPackingListData(this.asnNo);
                //console.log("📦 Packing List Data:", packingListResponse);

                if (!packingListResponse || packingListResponse.length === 0) {
                    console.error("❌ Packing List 데이터 없음");
                    return;
                }

                // ✅ 오늘 날짜 가져오기 (YYYYMMDD 포맷)
                const today = new Date();
                const yyyy = today.getFullYear();
                const mm = String(today.getMonth() + 1).padStart(2, '0');
                const dd = String(today.getDate()).padStart(2, '0');
                const estimatedDate = `${yyyy}${mm}${dd}`;

                // ✅ 첫 번째 데이터에서 정보 추출
                const firstItem = packingListResponse[0];

                // ✅ 요청 데이터 생성
                const requestData = {
                    offsetNo: firstItem.ASN_NO,
                    destination: firstItem.CARRIER_NM,
                    offsetIdx: firstItem.ASN_NO.slice(-3), // 마지막 3자리 추출
                    estimatedDate: estimatedDate,
                    contNo: firstItem.ASN_NO,
                    supplier: firstItem.CUST_NM,
                    custCD: firstItem.CUST_CD,
                    categoryPlace: firstItem.BL_NO,
                    palQty: packingListResponse.reduce((sum, item) => sum + (item.SHIP_QTY || 0), 0),
                    tableData: packingListResponse.map(item => ({
                        ITMNO: item.ITEM_NO,
                        ITM_NM: item.ITEM_NM,
                        TOTAL_QTY: item.SHIP_QTY,
                        BOX_LOT: item.CONT_NO,
                        REMARK: '' // 공백 값
                    }))
                };

                //console.log("✅ 변환된 데이터:", requestData);


                // ✅ API 요청
                const response = await axios.post("/api/createPdf", requestData, {
                    responseType: "blob" // ✅ PDF 파일을 Blob으로 받음
                });

                if (response.status === 200) {
                    // ✅ PDF를 새로운 창에서 오픈
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");
                    this.isPackingListPrinted = true; // ✅ 버튼 활성화

                    if (newWindow) {
                        // ✅ 창 내부에 HTML 직접 주입
                        newWindow.document.write(`
                        <html>
                            <head>
                            <title>Packing List Preview</title>
                            <style>
                                body {
                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                height: 100vh;
                                }
                                iframe {
                                flex: 1;
                                border: none;
                                width: 100%;
                                }
                                button {
                                padding: 10px 20px;
                                font-size: 16px;
                                font-weight: bold;
                                background-color: #007bff;
                                color: white;
                                border: none;
                                cursor: pointer;
                                margin: 10px;
                                }
                            </style>
                            </head>
                            <body>

                            <iframe src="${fileURL}"></iframe>
                            </body>
                        </html>
                        `);
                    } else {
                        alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                    }              
                } else {
                    console.error("❌ PDF 생성 실패:", response.status);
                }
            } catch (error) {
                console.error("❌ Packing List Print API 호출 실패:", error);
            }
        },

        async getPackingListData(asnNo) {
            try {
                const response = await axios.get("/api/getPackingListData", {
                    params: { asnNo }
                });

                //console.log("✅ API 응답 데이터:", response.data); // 🔥 추가

                if (response.status === 200 && response.data.success && Array.isArray(response.data.packingListData)) {
                    //console.log("✅ Packing List Data:", response.data.packingListData);
                    return response.data.packingListData;
                } else {
                    console.error("❌ Packing List 데이터 형식이 올바르지 않음", response.data);
                    return [];
                }
            } catch (error) {
                console.error("❌ getPackingListData API 호출 실패:", error);
                return [];
            }
        },


        handleAddLot(poDetail, lotDate) {
            if (!lotDate) {
                alert("Select Date to Add");
                return;
            }

            const today = new Date().toISOString().split("T")[0]; // 오늘 날짜 (YYYY-MM-DD)

          
            // 🚨 미래 날짜 방지
            if (this.isPalletPrintCompany) {
                if (lotDate > today) {
                    alert("You cannot select a future date.");
                    return;
                }
            }

            if (this.additionalTables[poDetail] && this.additionalTables[poDetail].some(entry => entry.lotDate === lotDate)) {
                alert("This Departure Date is already added.");
                return;
            }
            if (
                this.isMexicoPalletCompany &&
                this.additionalTables[poDetail] &&
                this.additionalTables[poDetail].length >= 1
            ) {
                alert("⚠️ You can only add one Lot Date per PO Detail.");
                return;
            }
            if (
            !this.isPalletPrintCompany &&
            this.additionalTables[poDetail] &&
            this.additionalTables[poDetail].length >= 1
            ) {
            alert("⚠️ Only one Departure Date is allowed per PO Detail for P1300 or P0801.");
            return;
            }

            const lotNo = this.translateToLot(lotDate);
            

            if (!this.additionalTables[poDetail]) {
                this.additionalTables[poDetail] = [];
            }

            this.additionalTables[poDetail].push({
                lotDate: lotDate,  // 저장된 Lot Date 추가
                lotNo: lotNo,
                originalLotNo: lotNo, // ✅ 원본 백업
                rackType: "None",
                quantity: 0,
                copies: 2
            });

        },
        handleRemoveTable(poDetail, index) {
            if (this.additionalTables[poDetail]) {
                this.additionalTables[poDetail].splice(index, 1);
                this.updateOrderPOQty(poDetail);

            }
        },
        updateOrderPOQty(poDetail) {
            let item = this.items.find(i => i.poDetail === poDetail);
            if (item) {
                let totalLotQty = (this.additionalTables[poDetail] || []).reduce(
                    (sum, lot) => sum + (Number(lot.quantity) || 0),
                    0
                );
                item.orderPOQuantity = totalLotQty; // ✅ Lot의 수량 합산
            }
        },
        closeScreen() { 
            //console.log('checking', this.additionalTables)
            for (const lots of Object.values(this.additionalTables)) {
                for (const lot of lots) {
                    // ✅ 원본으로 복원
                    if (lot.originalLotNo) {
                        lot.lotNo = lot.originalLotNo;
                    }
                }
            }
            this.$emit("close-modal");
            this.pdfDetailsForMexico = [];
            this.boxdetail = [];
            this.items = [];
        }
    }
};
</script>

<style scoped>
v-table {
  width: 100%;
  border-collapse: collapse; /* ✅ 테이블 선 겹침 방지 */
}

th, td {
  padding: 10px; /* ✅ 셀 간 여백 추가 */
  text-align: center;
  border: 1px solid #ddd; /* ✅ 모든 셀에 테두리 추가 */
}
.table-row {
  border-bottom: 1px solid #ddd; /* ✅ 아래쪽 테두리 추가 */
}

.table-row:last-child {
  border-bottom: none; /* ✅ 마지막 행은 테두리 제거 (깔끔한 디자인) */
}
.custom-text {
    font-size: 16px;
    font-weight: bold;
    color: #374151;
    margin-left: 35px;
}
.custom-label2::after {
    content: "";
    position: absolute;
    left: 100px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 180%;
    background-color: #d1d5db;
    }

.custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding-left: 12px;
    }

    .custom-value {
    flex: 1;
    text-align: left;
    color: #374151;
    padding-left: 20px;
    }

    /* ✅ Vuetify 기본 입력 필드 테두리, 그림자 제거 */
    .custom-input .v-input__control {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    min-height: 0 !important; /* ✅ 불필요한 높이 제거 */
    height: 100% !important;
    }

    /* ✅ 숫자 필드의 기본 스핀 버튼 완전 제거 */
    .custom-input input {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Chrome, Safari */
    appearance: none !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
    text-align: left;
    background: transparent !important; /* ✅ 배경 투명화 */
    border: none !important; /* ✅ 테두리 제거 */
    box-shadow: none !important; /* ✅ 불필요한 박스 제거 */
    }

    /* ✅ Vuetify에서 자동 생성되는 불필요한 UI 요소 제거 */
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    }

    /* ✅ v-text-field 내부 입력 필드 정렬 */
    .custom-input .v-input__control {
    display: flex !important;
    align-items: center !important;
    }

    /* ✅ 불필요한 여백 제거 */
    .custom-input input {
    margin: 0 !important;
    padding: 0 !important;
    }
.container-input {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 500px;
    height: 45px;
    }
    .custom-label2 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;

    background-color: #e8f0fe; /* 💡 배경색 추가 */

    }

.custom-table {
    width: 100%;
    table-layout: fixed; /* 테이블 크기 고정 */
}
.custom-table2 {
    width: 60%; /* 원하는 크기로 설정 */
    float: right;
}


.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.sub-table-row {
  background-color: #f9f9f9;
}

.lot-input {
  width: 100%;
  padding: 5px;
  text-align: right;
}

.lot-input5 {
  width: 100%;
  padding: 5px;
  text-align: center;
}

.add-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

:deep(.v-data-table__expand-icon) {
    display: none !important;
}

/* ✅ 확장된 행 스타일 */
.sub-table-row {
  background-color: #f9f9f9;
}

/* ✅ 테이블 스타일 */
.custom-table :deep(th) {
  font-weight: bold;
  text-align: center;
}

.custom-container {
    max-width: 1400px; /* ✅ 컨테이너 최대 너비 */
    width: 90%; /* ✅ 기본 너비 */
    margin: 0 auto; /* ✅ 중앙 정렬 */
    padding: 10px; /* ✅ 내부 여백 조절 */
}

.custom-card {
    max-width: 1200px; /* ✅ 카드 최대 너비 설정 */
    width: 80%; /* ✅ 가변적 크기 조절 */
    margin: 0 auto; /* ✅ 중앙 정렬 */
}

.custom-table-card {
    max-width: 1400px; /* ✅ 테이블이 포함된 카드 크기 */
    width: 90%;
    margin: 0 auto;
}

  :deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  }
  
  .data-table-row td {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  
  .data-table-row td {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  

  
  .modal-xl {
    max-width: 1500px;
  }
  
  .modal-table td,
  .modal-table tr {
    text-align: center;
  }
  
  .modal-table td input {
    margin: 0 auto;
  }
  
  .box-qty-input {
    max-width: 150px;
  }
  
  .box-input-control {
    width: 80%;
    text-align: center;
  }
  
  .custom-header-border {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  
  .custom-font-title {
    font-size: xx-large;
    color: black;
  }
  
  .custom-text-color {
    color: black;
    font-weight: 700;
  }
  .data-table-row:hover {
    background-color: #f5f5f5;
    /* 마우스 오버 시 배경색 변경 */
    cursor: pointer;
  }
  .modal-content {
    height: 90vh; /* ✅ 모달 내부 높이 조절 */
    max-width: 180vh;
    overflow-y: auto; /* ✅ 내용이 많으면 스크롤 가능하게 설정 */
}
.custom-table th {
    background-color: #e3f2fd !important; /* 연한 파란색 배경 */
    font-weight: bold !important;
    text-align: center !important;
    padding: 10px;
}

.red-text {
    color: red;
    font-weight: bold;
}

.blue-text {
    color: rgb(77, 77, 255);
    font-weight: bold;
}
.v-table thead {
  background-color: #e3f2fd !important; /* 연한 파란색 */
  color: black !important; /* 글씨 색 */
  font-weight: bold !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

.custom-table th:nth-child(3) { width: 200px; } /* Part Name */
.custom-table th:nth-child(4) { width: 130px; } /* PO Number Detail */
.custom-table th:nth-child(5) { width: 130px; } /* Part Number */
.custom-table th:nth-child(6) { width: 130px; } /* Part Name */
.custom-table th:nth-child(7) { width: 130px; } /* Part Name */
.custom-table th:nth-child(8) { width: 150px; } /* Part Name */
.custom-table th:nth-child(9) { width: 120px; } /* Part Name */

.lot-input2 {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-weight: bold;
  font-size: 15px;
  border: 2px solid #1976d2; /* 파란 테두리 */
  border-radius: 6px;
  background-color: #e3f2fd; /* 연한 파란 배경 */
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1); /* 안쪽 그림자 */
}

@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'HyundaiSansText' !important;
}

.custom-card-title {
  background-color: #6ea6d9; /* 파란 배경 */
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px 20px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.custom-card-box {
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
}

.custom-confirm-btn {
  font-weight: bold;
  padding: 10px 20px;
  font-size: 15px;
  letter-spacing: 0.5px;
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 123, 255, 0.3);
  background-color: #0068d6;
  color: #ffffff !important;

}

.custom-cancel-btn {
  font-weight: bold;
  padding: 10px 20px;
  font-size: 15px;
  letter-spacing: 0.5px;
  border-radius: 8px;
  border: 1.5px solid #ccc;
  /* Cancel */
    background-color: #e23240;
    color: #ffffff !important;
}
.btn-icon {
  padding-left: 10px;
  margin-right: 1vh;            /* 아이콘과 글자 간격 */
  font-size: 20px;              /* 아이콘 크기 */
  color: #ffffff !important;    /* 파란색 계열로 강조 */
  vertical-align: middle;       /* 아이콘 정렬 보정 */
}
.text-lift-up {
  position: relative;
  top: -1px; /* 👈 딱 1픽셀 위로 */
}

.add-btn {
  background-color: #1976d2; /* 파란색 */
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
  transition: background-color 0.3s ease;
}
.add-btn:hover {
  background-color: #125ea9; /* 호버 시 더 진한 파랑 */
}
.delete-btn {
  background-color: #e53935; /* 빨간색 */
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
  transition: background-color 0.3s ease;
}
.delete-btn:hover {
  background-color: #c62828; /* 호버 시 진한 빨강 */
}

.split-box {
  display: flex;
  width: 400px;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.label-box {
  background-color: #eaebece1; /* 🔵 라벨 배경색 */
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}

.select-box {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
  font-weight: bold;
}
.value-box {
  flex: 1;
  font-weight: bold;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
}

.improved-table th {
  background-color: #e3f2fd;
  font-size: 14px;
  text-align: center;
  vertical-align: middle;
  padding: 12px;
}

.improved-table td {
  padding: 10px;
  text-align: center;
}

.col-product-number {
  width: 160px;
  text-align: center;
}
.col-product-name {
  width: 200px;
  text-align: center;

}
.col-lot-no {
  width: 120px;
  text-align: center;

}
.col-delivery-qty {
  width: 130px;
  text-align: right;
}
.col-per-container {
  width: 180px;
}
.col-rack-qty {
  width: 180px;
}
v-table th {
  text-align: center;
  vertical-align: middle;
}
:deep(.v-table th) {
  text-align: center;
  vertical-align: middle;
}

:deep(.v-table thead tr th) {
  text-align: center !important;
  vertical-align: middle !important;
}

.lot-suffix-input {
  font-weight: bold;
}

:deep(.copies-cell .v-field) {
  height: 43px;
}

:deep(.copies-cell .v-field__input) {
  padding-top: 6px;
  padding-bottom: 6px;
  top: -3px;
  position: relative;
}

:deep(.copies-cell .v-field__append-inner) {
  top: -4px;
  position: relative;
}

</style>
